import React from 'react'

import { ZariContext } from '_zari/context'
import queryString from 'query-string'

import { Portlet } from '_zari/core'

import { CodigosTransaccionesConstant, OrigenesContabilidadConstant } from 'constants/index'

import { IdGen } from 'utils'

import MainForm from './mainForm'

import * as AsientoContableService from 'services/asientosContables.service'

const NuevoAsientoContable = ({ match, location }) => {
  const __zariContext = React.useContext(ZariContext)

  const [_mainFormKey, setMainFormKey] = React.useState(null)
  const [edicionInfo, setEdicionInfo] = React.useState({})
  const [prevData, setPrevData] = React.useState({})

  const flagCanjeGuias = React.useMemo(() => {
    let { formato } = queryString.parse(location.search)

    return formato === 'canje-guias'
  }, [location.search])

  const portletBreadcrumbs = React.useMemo(() => {
    let { origen } = queryString.parse(location.search)

    const nombreOrigen = OrigenesContabilidadConstant.__dictionary[origen].nombre

    return [
      {
        name: 'Asientos Contables',
        path: `/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}`
      },
      { name: `Origen ${nombreOrigen}` }
    ]
  }, [location.search])

  React.useEffect(() => {
    if (match.params.idAsientoContable) {
      AsientoContableService.getAsEdicion(match.params.idAsientoContable)
        .then(({ data }) => {
          setEdicionInfo(data)
          setMainFormKey(IdGen.newId())
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
    } else {
      setMainFormKey(IdGen.newId())
    }
  }, [match.params.idAsientoContable, __zariContext])

  const resetMainForm = React.useCallback(newPrevData => {
    setEdicionInfo({})
    setPrevData(newPrevData)
    setMainFormKey(IdGen.newId())
  }, [])

  return (
    <Portlet>
      <Portlet.Header title='Asientos Contables' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        {_mainFormKey && (
          <MainForm
            key={_mainFormKey}
            edicionInfo={edicionInfo}
            resetMainForm={resetMainForm}
            prevData={prevData}
            flagCanjeGuias={flagCanjeGuias}
          />
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(NuevoAsientoContable)
